import React from 'react';
import MobileGridDynamic300x250Fs from './freestar/MobileGridDynamic300x250';
const MobileGridDynamic300x250 = ({ safety ='off' , rowId  })=>{
    return /*#__PURE__*/ React.createElement(MobileGridDynamic300x250Fs, {
        safety: safety,
        rowId: rowId
    });
};
MobileGridDynamic300x250.displayName = 'MobileGridDynamic300x250';
export default MobileGridDynamic300x250;
